import React from 'react';

export default function Header() {
  return (
    <React.Fragment>
      <h1><strong>Atwood Rentals HVAC LLC.</strong></h1>
      <h4>MAIL PAYMENTS TO: P.O. BOX 489, MILAN, TN 38358</h4>
      <h5>
        PHONE (833) RTO-HVAC<br />
        FAX (731)686-0067<br />
        EMAIL: applicationteam@atwoodhvac.com<br />
        WEBSITE: www.atwoodrentalshvac.com
      </h5>
      <h3><strong>RENTAL PURCHASE AGREEMENT AND DISCLOSURE</strong></h3>
    </React.Fragment>
  );
}
